<template>
  <div class="survey-template" v-if="ready">
    <table v-if="dataSurvey">
      <thead>
        <tr class="blue accent-4 white-text">
          <th colspan="2">Wind Hazard</th>
        </tr>
        <tr>
          <th>Question</th>
          <th>Answer</th>
        </tr>
      </thead>
      <tbody class="windHazard">
        <tr v-for="(items, key) in windHazardSchema" :key="key">
          <td>{{ items.label }}</td>
          <td class="center-align" v-if="dataSurvey.survey[key] === true">

            <span v-html="NA_Check(key, true)"></span>
          </td>
          <td class="center-align" v-if="dataSurvey.survey[key] === '' || dataSurvey.survey[key] === false">
            <!--   {{dataSurvey.survey[key]}} -->

            <span v-html="NA_Check(key)"></span>
            <!--  <i class="material-icons-outlined red-text text-lighten-2">
              cancel
            </i> -->
          </td>
          <td class="center-align" v-if="dataSurvey.survey[key] === 'good' ||
            dataSurvey.survey[key] === 'poor' ||
            dataSurvey.survey[key] === 'fair'">
            {{ dataSurvey.survey[key] }}
          </td>
        </tr>
      </tbody>
    </table>

    <summary-assessment summary-label="Wind Hazard" :data-value="dataSurvey" data-survey="wind-hazard" />
  </div>
</template>

<script>
import { schema } from "@/schemas/windHazard.js";
import windHazardSchema from "@/JsonSchemas/windHazard.json";
import summaryAssessment from "@/components/admin/summaryAssessment.component";
export default {
  name: "WindHazardReview",
  components: {
    summaryAssessment,
  },
  props: {
    dataHomeprofile: {
      type: Object,
    },
    dataSurvey: {
      type: Object,
    },
  },
  data() {
    return {
      ready: true,
      form: this.dataSurvey.survey,
      NA_values: {},
      schema,
      windHazardSchema,
      ready: false,
    };
  },
  created() {
    Object.keys(this.schema).forEach(x => {
      if (this.schema[x] && this.schema[x].preState) {
        this.NA_values[x] = this.schema[x].preState
      }
    })
  },
  mounted() {
    this.ready = true

  },
  methods: {
    NA_Check(prop, value) {
      if (this.NA_values[prop]) {
        //console.log(this.dataHomeprofile.survey[this.NA_values[prop].option][0] === this.NA_values[prop].value)
        return this.dataHomeprofile.survey[this.NA_values[prop].option][0] === this.NA_values[prop].value
          ? 'N/A'
          : !value
            ? `<i class="material-icons red-text text-lighten-2">cancel</i>`
            : `<i class="material-icons-outlined green-text text-lighten-2">task_alt</i>`
      } else {
        return value ? `<i class="material-icons-outlined green-text text-lighten-2">task_alt</i>` : `<i class="material-icons red-text text-lighten-2">cancel</i>`
      }

    }
  },
};
</script>
<style lang="scss" scoped>
table {
  thead {
    background: rgba(0, 0, 0, 0.08);
    padding: 12px;
  }
}

td,
th {
  border: 1px solid lightgray !important;
  padding: 12px;

  p {
    margin: 6px 0px;
  }
}

.survey-template {
  /*   table {
    margin-bottom: 50px;
    tr {
      td {
        padding: 10px;
        border: 1px solid lightgray !important;
        &:nth-child(2) {
          text-align: center;
          width: 100px;
        }
      }
    }
  } */
}
</style>
